// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"521":"81b17bce","830":"ecd23fb1"}[chunkId] + ".chunk.js";
};